export const structure = {
  label: 'Grupo',
  title: 'Estructura Empresarial',
  subtitle: 'Visión general de DR Group y sus participaciones',
  holdco: {
    name: 'DR Group GmbH',
    type: 'Holding de participaciones'
  },
  participations: {
    s4chain: {
      name: 'S4Chain GmbH',
      status: 'Operativa',
      description: 'Los servicios son prestados exclusivamente por S4Chain',
      link: 'Visitar sitio web'
    },
    placeholder: 'Participaciones adicionales'
  },
  future: {
    title: 'Future PropCo',
    subtitle: 'Marcador de posición conceptual'
  }
};